// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-screen-footer {
  display: flex;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black4);
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  background: var(--black0);
  padding: 0 0 2rem 0;
}
.auth-screen-footer > div {
  padding-left: 0.75rem;
  margin-left: 0.75rem;
  border-left: 1px solid var(--black1);
}
.auth-screen-footer > div a {
  margin: 0 0.75rem;
  color: var(--black4);
  cursor: pointer;
}
.auth-screen-footer > div a:first-child {
  margin-left: 0;
}
.auth-screen-footer > div a:last-child {
  margin-right: 0;
}
.auth-screen .auth-content {
  position: relative;
  width: 500px;
  height: auto;
  display: flex;
  align-items: center;
  padding: 2rem;
  background: var(--white);
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
  border-radius: 0.5rem;
}
.auth-screen .auth-content-title {
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  color: var(--black9);
  margin-bottom: 0.5rem;
}
.auth-screen .auth-content-details {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--black5);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}
.auth-screen .auth-content-subfooter {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: var(--black5);
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}
.auth-screen .auth-content-subfooter a {
  font-weight: 500;
}
.auth-screen .auth-content-subfooter > div {
  display: inline-block;
}
.auth-screen .auth-content-logo {
  position: absolute;
  top: -3.5rem;
  right: 50%;
  transform: translate(50%, 0);
}
.auth-screen .auth-content-form {
  margin-bottom: 0;
  width: 100%;
}
.auth-screen .auth-content-form .forgot-password {
  color: var(--purple6);
}
.auth-screen .auth-content-store-name-wrapper {
  display: flex;
  justify-content: space-between;
}
.auth-screen .auth-content-store-name-input {
  margin-bottom: 1.5rem;
  width: 100%;
}
.auth-screen .auth-content-store-name-input input {
  border-radius: 0.5rem 0 0 0.5rem;
  box-shadow: none;
}
.auth-screen .auth-content-store-name-paylixecommerce {
  border-radius: 0 0.5rem 0.5rem 0;
  height: 40px;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.8rem !important;
  border: 1px solid var(--black2);
  border-left: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: var(--black9);
}
.auth-screen .auth-content-line {
  width: 100%;
  padding: 1rem 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--black4);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.auth-screen .auth-content-line:before {
  content: "";
  display: block;
  border-top: solid 1px var(--black1);
  width: 100%;
  height: 1px;
  position: absolute;
  top: 50%;
  z-index: 1;
}
.auth-screen .auth-content-line span {
  background: #fff;
  padding: 0 16px;
  position: relative;
  z-index: 5;
  margin-bottom: 0;
}
.auth-screen .auth-content-google {
  height: 44px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-screen .auth-content-google img {
  height: 1rem;
  width: 1rem;
  margin-right: 0.75rem;
}

.message {
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  margin-top: 0;
  margin-bottom: 24px;
  font-weight: 400;
  font-size: 13px;
  text-align: left;
}
.message div {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0.5rem;
}

.auth-error {
  background: var(--purple0);
  border: 1px solid var(--purple6);
  color: var(--purple9);
}
.auth-error div {
  color: var(--purple6);
}

.auth-confirm {
  background: var(--green0);
  border: 1px solid var(--green6);
  color: var(--green9);
}
.auth-confirm div {
  color: var(--green6);
}

@media (max-width: 768px) {
  #app > div .auth-screen {
    padding: 7rem 0 3rem 0;
  }
  #app > div .auth-screen-footer {
    padding-bottom: 1rem;
  }
  #app > div .auth-screen .auth-content {
    width: calc(100% - 2rem);
    padding: 1.25rem;
  }
  #app > div .auth-screen .auth-content button.large {
    height: 2.25rem;
  }
  #app > div .auth-screen .auth-content-title {
    font-size: 18px;
    line-height: 22px;
    text-align: center !important;
  }
  #app > div .auth-screen .auth-content-details {
    font-size: 13px;
    line-height: 18px;
    margin-bottom: 1.25rem;
    text-align: center !important;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/auth/index.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AADJ;AAGI;EACE,qBAAA;EACA,oBAAA;EACA,oCAAA;AADN;AAGM;EAOE,iBAAA;EACA,oBAAA;EACA,eAAA;AAPR;AADQ;EACE,cAAA;AAGV;AADQ;EACE,eAAA;AAGV;AAME;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;EACA,iFAAA;EACA,qBAAA;AAJJ;AAMI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;AAJN;AAOI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AALN;AAQI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAPN;AASM;EACE,gBAAA;AAPR;AAUM;EACE,qBAAA;AARR;AAYI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;AAVN;AAaI;EACE,gBAAA;EACA,WAAA;AAXN;AAaM;EACE,qBAAA;AAXR;AAkBM;EACE,aAAA;EACA,8BAAA;AAhBR;AAmBM;EACE,qBAAA;EACA,WAAA;AAjBR;AAmBQ;EACE,gCAAA;EACA,gBAAA;AAjBV;AAqBM;EACE,gCAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,iBAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AApBR;AAyBI;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAvBN;AAyBM;EACE,WAAA;EACA,cAAA;EACA,mCAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAvBR;AA0BM;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAxBR;AA4BI;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1BN;AAoCM;EACE,YAAA;EACA,WAAA;EACA,qBAAA;AAlCR;;AA2CA;EACE,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAxCF;AA0CE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAxCJ;;AA4CA;EACE,0BAAA;EACA,gCAAA;EACA,qBAAA;AAzCF;AA2CE;EACE,qBAAA;AAzCJ;;AA6CA;EACE,yBAAA;EACA,+BAAA;EACA,oBAAA;AA1CF;AA4CE;EACE,oBAAA;AA1CJ;;AA+CA;EACE;IACE,sBAAA;EA5CF;EA8CE;IACE,oBAAA;EA5CJ;EA+CE;IACE,wBAAA;IACA,gBAAA;EA7CJ;EA+CI;IACE,eAAA;EA7CN;EAgDI;IACE,eAAA;IACA,iBAAA;IACA,6BAAA;EA9CN;EAiDI;IACE,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,6BAAA;EA/CN;AACF","sourcesContent":[".auth-screen {\n\n  &-footer {\n    display: flex;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: var(--black4);\n    white-space: nowrap;\n    align-items: center;\n    justify-content: center;\n    background: var(--black0);\n    padding: 0 0 2rem 0;\n\n    & > div {\n      padding-left: .75rem;\n      margin-left: .75rem;\n      border-left: 1px solid var(--black1);\n\n      a {\n        &:first-child {\n          margin-left: 0;\n        }\n        &:last-child {\n          margin-right: 0;\n        }\n        margin: 0 .75rem;\n        color: var(--black4);\n        cursor: pointer;\n      }\n    }\n  }\n\n  .auth-content {\n    position: relative;\n    width: 500px;\n    height: auto;\n    display: flex;\n    align-items: center;\n    padding: 2rem;\n    background: var(--white);\n    box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n    border-radius: .5rem;\n\n    &-title {\n      font-weight: 600;\n      font-size: 24px;\n      line-height: 29px;\n      text-align: center;\n      color: var(--black9);\n      margin-bottom: .5rem;\n    }\n\n    &-details {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n      text-align: center;\n      color: var(--black5);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 1.5rem;\n    }\n\n    &-subfooter {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 17px;\n      text-align: center;\n      color: var(--black5);\n      margin-top: 1rem;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: .25rem;\n\n      a {\n        font-weight: 500;\n      }\n\n      & > div {\n        display: inline-block;\n      }\n    }\n\n    &-logo {\n      position: absolute;\n      top: -3.5rem;\n      right: 50%;\n      transform: translate(50%, 0);\n    }\n\n    &-form {\n      margin-bottom: 0;\n      width: 100%;\n\n      .forgot-password {\n        color: var(--purple6);\n      }\n\n    }\n\n    &-store-name {\n\n      &-wrapper {\n        display: flex;\n        justify-content: space-between;\n      }\n\n      &-input {\n        margin-bottom: 1.5rem;\n        width: 100%;\n\n        input {\n          border-radius: .5rem 0 0 .5rem;\n          box-shadow: none;\n        }\n      }\n\n      &-paylixecommerce {\n        border-radius: 0 .5rem .5rem 0;\n        height: 40px;\n        padding: 0 1rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-top: 1.8rem !important;\n        border: 1px solid var(--black2);\n        border-left: none;\n\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 17px;\n        text-align: center;\n        color: var(--black9);\n      }\n\n    }\n\n    &-line {\n      width: 100%;\n      padding: 1rem 0;\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--black4);\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n      text-align: center;\n\n      &:before {\n        content: '';\n        display: block;\n        border-top: solid 1px var(--black1);\n        width: 100%;\n        height: 1px;\n        position: absolute;\n        top: 50%;\n        z-index: 1;\n      }\n\n      span {\n        background: #fff;\n        padding: 0 16px;\n        position: relative;\n        z-index: 5;\n        margin-bottom: 0;\n      }\n    }\n\n    &-google {\n      height: 44px;\n      overflow: hidden;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      & > div {\n        //height: 44px !important;\n      }\n\n      iframe {\n        //margin: 0 auto !important;\n      }\n\n      img {\n        height: 1rem;\n        width: 1rem;\n        margin-right: .75rem;\n      }\n    }\n\n  };\n\n}\n\n\n.message {\n  padding: 1rem 1.25rem;\n  border-radius: .5rem;\n  margin-top: 0;\n  margin-bottom: 24px;\n  font-weight: 400;\n  font-size: 13px;\n  text-align: left;\n\n  div {\n    display: flex;\n    align-items: center;\n    gap: .25rem;\n    font-weight: 600;\n    font-size: 14px;\n    margin-bottom: .5rem;\n  }\n}\n\n.auth-error {\n  background: var(--purple0);\n  border: 1px solid var(--purple6);\n  color: var(--purple9);\n\n  div {\n    color: var(--purple6);\n  }\n}\n\n.auth-confirm {\n  background: var(--green0);\n  border: 1px solid var(--green6);\n  color: var(--green9);\n\n  div {\n    color: var(--green6);\n  }\n}\n\n\n@media (max-width: 768px) {\n  #app > div .auth-screen {\n    padding: 7rem 0 3rem 0;\n\n    &-footer {\n      padding-bottom: 1rem;\n    }\n\n    .auth-content {\n      width: calc(100% - 2rem);\n      padding: 1.25rem;\n\n      button.large {\n        height: 2.25rem;\n      }\n\n      &-title {\n        font-size: 18px;\n        line-height: 22px;\n        text-align: center !important;\n      }\n\n      &-details {\n        font-size: 13px;\n        line-height: 18px;\n        margin-bottom: 1.25rem;\n        text-align: center !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
